module.exports = __webpack_public_path__ + "lockport_cave.d7f2bdbfc75fac47776e6f6adf5d1e06.png";